import { styled } from '@mui/material';

import { competitionWinnersQuery } from '@/lib/api/requests.ts';
import { getQueryClient } from '@/lib/query-client-context.ts';

import Page from '../../../../../components/Page/index.ts';
import runeBakken from '../../../april/pages/LandingPage/rune-bakken.webp';

import type { Route } from './+types/LandingPageJune';
import { Footer } from './_sections/Footer.tsx';
import { QuoteSection, type QuoteSectionProps } from './_sections/QuoteSection.tsx';
import { RulesSection } from './_sections/RulesSection.tsx';
import { StatsSection } from './_sections/StatsSection.tsx';
import { TimerSectionJune } from './_sections/TimerSectionJune.tsx';
import { TopSectionJune } from './_sections/TopSectionJune.tsx';

const Root = styled('div')({
  width: '100%',
  backgroundColor: 'white',
});

const quote: QuoteSectionProps = {
  photo: runeBakken,
  photoAlt: 'Rune Bakken (36)',
  photoCaption: 'Foto: Thomas Rasmus Skaug / Dagbladet',
  quote:
    '- Jeg hadde en forhåpning om at jeg kunne få lavere rente, men jeg hadde aldri trodd jeg skulle være så heldig at jeg vant.',
  quoteCaption: 'Sier Rune Bakken (36), vinner av April-trekningen, til Dagbladet',
  link: 'https://www.dagbladet.no/annonse/rune-vant-100-000-kroner-ved-a-sjekke-gjelden-sin/81381960',
};

export async function loader({ context }: Route.LoaderArgs) {
  const queryClient = getQueryClient(context);
  const competitions = await queryClient.query(competitionWinnersQuery());
  const competition = competitions.find((c) => c.slug === 'summer_2024_campaign');
  return {
    winners: competition?.winners,
  };
}

export default function LandingPage({ loaderData }: Route.ComponentProps) {
  return (
    <Page title="Sommerkampanje">
      <Root>
        <TopSectionJune winners={loaderData.winners} />
        <TimerSectionJune />
        <QuoteSection {...quote} />
        <RulesSection />
        <StatsSection />
        <Footer />
      </Root>
    </Page>
  );
}
